<template>
<div class="home">

  <v-parallax dark src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg">
    <v-layout align-center column justify-center>
      <h1 class="display-2 font-weight-thin mb-3">v-sendai</h1>
      <h4 class="subheading">vue.jsの仙台コミュニティです</h4>
      <h4 class="subheading">#v_sendai</h4>
    </v-layout>
  </v-parallax>

  <Timeline id="vuefes" sourceType="profile" :options="{ tweetLimit: '20', width: '480' }"/>

</div>
</template>

<script>
import Timeline from 'vue-tweet-embed/src/timeline'

export default {
  data() {
    return {
      mainlogo: "/logo_v_sendai.png"
    }
  },
  components: {
        Timeline: Timeline
  }
}
</script>